import React, { Component } from 'react';
import ReactS3Uploader from '../../packages/react-s3-uploader-fork';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './UploadDropzone.scss';

import { calculateAudioLength } from '../../helpers/helpers';
import { getAccessToken } from '../../helpers/user_helpers';

class UploadDropzone extends Component {
  static propTypes = {
    callId: PropTypes.number,
    user: PropTypes.object.isRequired,
    uploads: PropTypes.array.isRequired,
    setUploads: PropTypes.func.isRequired,
  };

  componentDidMount() {
    document.addEventListener('mouseout', this.setDraggedOff);
    document.addEventListener('mouseup', this.setDraggedOff);
  }
  state = {};

  areUploadsSame = (u1, u2) => u1.id === u2.id || u1.file.lastModified === u2.file.lastModified;

  startUpload = async (file) => {
    const { setUploads, uploads } = this.props;
    const upload = { file, is_complete: false, progress: 0, id: file.lastModified };
    const newUploads = [...uploads, upload];
    setUploads(newUploads);

    const duration_seconds = await calculateAudioLength(file);
    this.updateUpload(file, { duration_seconds });
  };

  updateUpload = (file, updates) => {
    const { setUploads, uploads } = this.props;
    const newUploads = uploads.map((u) => (this.areUploadsSame(u, { file }) ? { ...u, ...updates } : u));
    setUploads(newUploads);
  };

  setDraggedOn = () => this.setState({ isDraggedOver: true });
  setDraggedOff = () => this.setState({ isDraggedOver: false });

  render() {
    const { user } = this.props;
    const { isDraggedOver } = this.state;
    return (
      <div onDragOver={this.setDraggedOn} className={cn('upload-dropzone-outer-container', { 'dragged-over': isDraggedOver })}>
        <ReactS3Uploader
          accept='audio/mp3'
          preprocess={(info, next) => {
            const randomTime = Math.random() * 3; // Randomize it because of setState issues.
            setTimeout(() => {
              this.startUpload(info);
            }, randomTime);
            next(info);
          }}
          onError={(error) => this.errorOnUpload(error)}
          onFinish={({ signedUrl }, file) => {
            this.updateUpload(file, { is_complete: true, signed_url: signedUrl });
          }}
          onProgress={(progress, status, file) => {
            this.updateUpload(file, { progress, status, is_complete: false });
          }}
          uploadRequestHeaders={{}}
          signingUrlHeaders={{ Authorization: `Bearer ${getAccessToken(user)}` }}
          server={process.env.REACT_APP_API_URL}
          signingUrl='/s3/sign'
        />
        <div className='upload-header-container'>
          <div className='upload-header'>{isDraggedOver ? 'Drop' : 'Upload'} Your mp3 Files</div>
        </div>
      </div>
    );
  }
}

export default UploadDropzone;
